var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityPinnedLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5443_26728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20.0013H4V4.0013H14.6667V2.66797H4C3.64638 2.66797 3.30724 2.80844 3.05719 3.05849C2.80714 3.30854 2.66667 3.64768 2.66667 4.0013V20.0013C2.66667 20.3549 2.80714 20.6941 3.05719 20.9441C3.30724 21.1942 3.64638 21.3346 4 21.3346H20C20.3536 21.3346 20.6928 21.1942 20.9428 20.9441C21.1929 20.6941 21.3333 20.3549 21.3333 20.0013V9.33464H20V20.0013Z",
    fill: "#656464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.38 6.2215L17.7133 1.55484C17.5858 1.44562 17.4218 1.38855 17.254 1.39503C17.0862 1.40151 16.927 1.47106 16.8083 1.58979C16.6896 1.70852 16.62 1.86768 16.6135 2.03547C16.607 2.20325 16.6641 2.3673 16.7733 2.49484L21.44 7.1615C21.4998 7.23129 21.5733 7.28797 21.656 7.32799C21.7387 7.368 21.8288 7.39049 21.9206 7.39404C22.0124 7.39758 22.104 7.38211 22.1896 7.34859C22.2751 7.31508 22.3528 7.26424 22.4178 7.19927C22.4827 7.1343 22.5336 7.0566 22.5671 6.97105C22.6006 6.8855 22.6161 6.79395 22.6125 6.70213C22.609 6.61032 22.5865 6.52023 22.5465 6.43752C22.5065 6.35481 22.4498 6.28127 22.38 6.2215Z",
    fill: "#656464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7333 7.46167L15.2 7.795L17.64 5.335L16.6667 4.375L15.0067 6.08833C13.6733 5.50833 12.1067 6.18167 11.06 7.20833L10.58 7.68167L12.94 10.0417L10.4933 12.4883L11.4333 13.4283L13.88 10.9817L16.2467 13.335L16.72 12.855C17.7467 11.8083 18.42 10.2417 17.84 8.90167L19.5333 7.18833L18.5867 6.255L16.14 8.735L16.4667 9.195C16.9733 9.86167 16.6333 10.775 16.1933 11.415L12.5133 7.735C13.2267 7.24167 14.1 7.00167 14.7333 7.46167Z",
    fill: "#656464"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5443_26728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityPinnedLine);
export default __webpack_public_path__ + "static/media/clarity_pinned-line.2e747cac8833ccc1847fea53ec9ae835.svg";
export { ForwardRef as ReactComponent };